var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c, _d;
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Playlists } from '@lean-body/components/molecules';
import { MoreLoading } from '@lean-body/components/atoms';
import { useSmMediaQuery } from '@lean-body/src/util';
import { PaginationNextButton } from '../atoms/pagination_next_button';
import { SearchConditionsButtonWithDialog, SelectOption, selectOptions } from '@lean-body/components/organisms';
import { MediaBreakPointUp } from '@lean-body/components/styles';
var PROGRAMS_PAGING_PER_LENGTH = 20;
var INIT_PAGE = -1; // 最初のページが0なのでinitを-1にしている
export var MainPlaylists = function (_a) {
    var apiClient = _a.apiClient;
    var isSM = useSmMediaQuery();
    var _b = React.useState(INIT_PAGE), page = _b[0], setPage = _b[1];
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useState([]), playlists = _d[0], setPlaylist = _d[1];
    var _e = React.useState(false), allLoaded = _e[0], setAllLoaded = _e[1];
    var _f = React.useState(SelectOption.NewArrival), selectedOption = _f[0], setSelectedOption = _f[1];
    var displaySortLabel = selectOptions.find(function (v) { return v.value === selectedOption; }).name;
    var availableNext = !allLoaded && playlists.length !== 0;
    var fetchPlaylists = function (currentPlaylists, currentPage) { return __awaiter(void 0, void 0, void 0, function () {
        var nextPage, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nextPage = currentPage + 1;
                    setLoading(true);
                    setPage(nextPage);
                    return [4 /*yield*/, apiClient.fetchPlaylists(nextPage, selectedOption)];
                case 1:
                    result = _a.sent();
                    setPlaylist(currentPlaylists.concat(result));
                    setLoading(false);
                    if (result.length < PROGRAMS_PAGING_PER_LENGTH)
                        setAllLoaded(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchNextPlaylists = function () { return fetchPlaylists(playlists, page); };
    React.useEffect(function () {
        fetchPlaylists([], INIT_PAGE);
    }, [selectedOption]);
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.searchConditionsContainer) },
            React.createElement(SearchConditionsButtonWithDialog, { label: displaySortLabel, currentValue: selectedOption, onChangeSort: setSelectedOption })),
        React.createElement(Playlists, { playlists: playlists, addFavoriteProgram: apiClient.addFavoriteProgram, unFavoriteProgram: apiClient.unFavoriteProgram, isSM: isSM, classObject: styles.playlists }),
        React.createElement(PaginationNextButton, { getNextPage: fetchNextPlaylists, isAvailable: availableNext, classObject: styles.paginationButton }),
        loading && React.createElement(MoreLoading, null)));
};
var styles = StyleSheet.create({
    container: (_a = {
            margin: '18px 16px 0'
        },
        _a[MediaBreakPointUp.MD] = {
            margin: '24px 50px 30px',
        },
        _a),
    searchConditionsContainer: {
        display: 'flex',
        maxWidth: 800,
        marginBottom: 16,
    },
    sortButton: (_b = {
            right: 15,
            textAlign: 'center'
        },
        _b[MediaBreakPointUp.MD] = {
            right: 50,
        },
        _b),
    sortButtonWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        width: '100%',
        marginTop: 15,
    },
    paginationButton: (_c = {
            margin: '0 auto 20px',
            width: 240
        },
        _c[MediaBreakPointUp.SM] = {
            margin: 'auto',
        },
        _c),
    playlists: (_d = {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
            gap: 10,
            ':before': {
                display: 'block',
                content: '""',
                width: 163,
                order: 1,
            }
        },
        _d[MediaBreakPointUp.MD] = {
            marginTop: 0,
            gap: 20,
        },
        _d),
});
